$(document).ready(function () {
    $("p.announcement-bar__message.h5 a").on("click", function () {
        // $("button.needsclick.kl-teaser-UWmahg").trigger("click");
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'R8pyiX']);
    })
})
// $(document).ready(checkContainerr);

// function checkContainerr() {
//   if($('.pwzrswiper-container-wrapper').is(':visible')){ //if the container is visible on the page
//     console.log("showing-now")
//     $("<button class='custom-view-in-your-space'>View in Your Space</button>").insertAfter(".pwzrswiper-slide [data-tagname='MODEL']");
//   } else {
//     //console.log("not found");
//     setTimeout(checkContainerr, 50); //wait 50 ms, then try again

//   }
// }
$(document).ready(function () {
// var elength = $(".PwzrGrid-root.rio-hide-scrollbar").find("div:empty").length;
    var wheight = $(".pwzrswiper-wrapper").height();

    var dindex = $('[data-tagname="MODEL"]').parents(".pwzrswiper-slide").attr("data-index");
    dindex = parseInt(dindex) + parseInt(1);
    console.log(dindex)
    var finaltr = parseFloat(dindex) * parseFloat(wheight)

    $('<button class="custom-view-in-your-space" id="myBtntoggle"> <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-3d-model" fill="none" viewBox="0 0 18 21">  <path d="M7.67998 20.629L1.28002 16.723C0.886205 16.4784 0.561675 16.1368 0.337572 15.731C0.113468 15.3251 -0.00274623 14.8686 -1.39464e-05 14.405V6.59497C-0.00238367 6.13167 0.113819 5.6755 0.33751 5.26978C0.561202 4.86405 0.884959 4.52227 1.278 4.27698L7.67796 0.377014C8.07524 0.131403 8.53292 0.000877102 8.99999 9.73346e-08C9.46678 -0.000129605 9.92446 0.129369 10.322 0.374024V0.374024L16.722 4.27399C17.1163 4.51985 17.4409 4.86287 17.6647 5.27014C17.8885 5.67742 18.0039 6.13529 18 6.59998V14.409C18.0026 14.8725 17.8864 15.3289 17.6625 15.7347C17.4386 16.1405 17.1145 16.4821 16.721 16.727L10.321 20.633C9.92264 20.8742 9.46565 21.0012 8.99999 21C8.53428 20.9998 8.07761 20.8714 7.67998 20.629V20.629ZM8.72398 2.078L2.32396 5.97803C2.22303 6.04453 2.14066 6.13551 2.08452 6.24255C2.02838 6.34959 2.00031 6.46919 2.00298 6.59003V14.4C2.00026 14.5205 2.02818 14.6396 2.08415 14.7463C2.14013 14.853 2.22233 14.9438 2.32298 15.01L7.99999 18.48V10.919C8.00113 10.5997 8.08851 10.2867 8.25292 10.0129C8.41732 9.73922 8.65267 9.51501 8.93401 9.36401L15.446 5.841L9.28001 2.08002C9.19614 2.02738 9.09901 1.99962 8.99999 2C8.90251 1.99972 8.8069 2.02674 8.72398 2.078V2.078Z" fill="currentColor"></path></svg>  View in Your Space</button>').insertAfter('[data-tagname="MODEL"]');

    $('<div class="main-custom-qr-code-scanner"><button class="custom-qr-code-scanner" > <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 2c1.654 0 3 1.346 3 3v14c0 1.654-1.346 3-3 3h-14c-1.654 0-3-1.346-3-3v-14c0-1.654 1.346-3 3-3h14zm0-2h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-8 8h-1v-2h1v1h2v1h-1v1h-1v-1zm2 12v-1h-1v1h1zm-1-15v-1h-2v1h1v1h1v-1zm8-1v6h-1v-1h-4v-5h5zm-1 4v-3h-3v3h3zm-14 2h-1v1h2v-1h-1zm0 3h1v1h1v-3h-1v1h-2v2h1v-1zm5 1v2h1v-2h-1zm4-10h-1v3h1v-3zm0 5v-1h-1v1h1zm3-2h1v-1h-1v1zm-10-1h-1v1h1v-1zm2-2v5h-5v-5h5zm-1 1h-3v3h3v-3zm9 5v1h-1v-1h-2v1h-1v-1h-3v-1h-1v1h-1v1h1v2h1v-1h1v2h1v-2h3v1h-2v1h2v1h1v-3h1v1h1v2h1v-1h1v-1h-1v-1h-1v-1h1v-1h-2zm-11 8h1v-1h-1v1zm-2-3h5v5h-5v-5zm1 4h3v-3h-3v3zm12-3v-1h-1v1h1zm0 1h-1v1h-1v-1h-1v-1h1v-1h-2v-1h-1v2h-1v1h-1v3h1v-1h1v-1h2v2h1v-1h1v1h2v-1h1v-1h-2v-1zm-9-3h1v-1h-1v1zm10 2v1h1v1h1v-3h-1v1h-1zm2 4v-1h-1v1h1zm0-8v-1h-1v1h1z"/></svg> </button> <span> View in your space </span></div>').insertAfter('[data-tagname="MODEL"]');
    var attributeValue = $(".qr_code_scanner").attr("qr-scaner");

    $(".main-custom-qr-code-scanner").hide();
    if (attributeValue !== "") {
        $(".main-custom-qr-code-scanner").show();
    }

    $(".main-custom-qr-code-scanner").click(function () {
        $(".qr_code_scanner").show();
        $("body").addClass("overflow-hidden");
    });
    $(".close-scanner-btn").click(function () {
        $(".qr_code_scanner").hide();
        $("body").removeClass("overflow-hidden");
    });
    $(".popup_overlay_custom").click(function () {
        $(".qr_code_scanner").hide();
        $("body").removeClass("overflow-hidden");
    });
    // });
    $(".custom-view-in-your-space").click(function () {
        $(".product__xr-button").trigger("click");
    });


//     $(".pwzrswiper-lazy").each(function(){
//   var model =$(this).attr('data-tagname') == 'MODEL';
//   if (model == true ) { 

//     console.log(model)
//    //   $(this).parent(".pwzrswiper-slide").prevAll().removeClass("pwzrswiper-slide-active");
//    //  $(this).parent(".pwzrswiper-slide").prevAll().removeClass("pwzrswiper-slide-next");
//    //    $(this).parent(".pwzrswiper-slide").nextAll().removeClass("pwzrswiper-slide-duplicate-prev");
//    // $(this).parent('.pwzrswiper-slide').addClass("pwzrswiper-slide-active");  
//    //   $(this).parent('.pwzrswiper-slide').next().addClass("pwzrswiper-slide-next");  
//      // $(this).parent('.pwzrswiper-slide').prev().addClass("pwzrswiper-slide-duplicate pwzrswiper-slide-prev");  
// }
// }); 
    setTimeout(function () {
        if (window.location.href.indexOf('?trigger=3dmodel') > 0) {
            $(".pwzrswiper-slide[data-index='" + dindex + "']").addClass("pwzrswiper-slide-active");
            $(".pwzrswiper-slide[data-index='" + dindex + "']").next().addClass("pwzrswiper-slide-next");
            $(".pwzrswiper-slide[data-index='" + dindex + "']").prev().addClass("pwzrswiper-slide-prev");
            $(".pwzrswiper-slide[data-index='" + dindex + "']").prevAll(".pwzrswiper-slide").removeClass("pwzrswiper-slide-active");
            $(".pwzrswiper-wrapper").css({"transform": "translate3d(-" + finaltr + "px, 0px, 0px)"});
        }
    }, 2000);

    $(document).on("click",".related-atc",function(e){
        e.preventDefault();
        $(this).attr("disabled","disabled");
        const cartDrawer = document.querySelector("cart-drawer");
        let vid = $(this).attr("data-variant-id");
        let qty = 1;
        fetch(`${routes.cart_add_url}.js`, {
            method:"POST",
            headers:{
                "Content-type":"application/json",
            },
            body:JSON.stringify({
                items:[
                    {
                        quantity:qty,
                        id:vid,
                    },
                ],
                sections: cartDrawer.getSectionsToRender().map((section) => section.id)
            })
        })
          .then((response) => response.json())
          .then((response) => {
            cartDrawer.renderContents(response);
          });
    });

    $(document).on("change",".related-product--variant-selector",function(e){
        e.preventDefault();
        var vid = $(this).val();
        var price = $(this).find("option:selected").attr("data-price");
        
        $(this).parents(".related-product-item").find(".related-atc").attr("data-variant-id",vid);
        $(this).parents(".related-product-item").find(".related-product-price").html(price);
    });
});





